'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClosed = isClosed;

var _ChatFilterOptions = require('../../constants/ChatFilterOptions');

var _threadGetters = require('./threadGetters');

function isClosed(conversation) {
  return (0, _threadGetters.getStatus)(conversation) === _ChatFilterOptions.ENDED;
}